var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2019 27.2617H71.7487C74.6808 27.2617 77.0926 29.6606 77.1083 32.5927L77.3281 73.5569C77.3438 76.4888 74.9578 78.8878 72.0258 78.8878H15.4789C12.5469 78.8878 10.135 76.4888 10.1193 73.5569L9.89949 32.5927C9.88377 29.6606 12.2698 27.2617 15.2019 27.2617Z",
    fill: "#BCBDC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7138 5.94101C65.7138 3.39608 63.6507 1.33301 61.1058 1.33301H31.4506L18.9492 13.8344V53.8852H65.7138V5.94101Z",
    fill: "#F6F6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4506 11.5304C31.4506 12.8029 30.4191 13.8344 29.1466 13.8344H18.9492L31.4506 1.33301V11.5304Z",
    fill: "#BCBDC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29418 36.2905H64.7058C67.125 36.2905 69.4879 38.2699 69.9566 40.6892L76.5046 74.4892C76.9733 76.9085 75.3774 78.8879 72.9581 78.8879H14.5465C12.1273 78.8879 9.76443 76.9085 9.29578 74.4892L2.74772 40.6892C2.27907 38.2699 3.87499 36.2905 6.29418 36.2905Z",
    fill: "#E2E2E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8937 13.6089C36.4719 13.0307 37.4178 13.0308 37.996 13.6089L42.332 17.945L46.6681 13.6089C47.2463 13.0308 48.1922 13.0307 48.7704 13.6089C49.3487 14.1872 49.3487 15.1331 48.7705 15.7112L44.4344 20.0474L48.7705 24.3834C49.3487 24.9616 49.3487 25.9075 48.7705 26.4857C48.1922 27.064 47.2464 27.064 46.6682 26.4858L42.332 22.1496L37.9959 26.4858C37.4177 27.064 36.4719 27.064 35.8936 26.4857C35.3154 25.9075 35.3154 24.9616 35.8936 24.3834L40.2298 20.0474L35.8936 15.7112C35.3154 15.1331 35.3154 14.1872 35.8937 13.6089Z",
    fill: "#F8323E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/noDataIcon.18e84022f8e36c07d196b4b84badb5fa.svg";
export { ForwardRef as ReactComponent };